<script lang="ts" setup>
import InputLabel from '@/components/inputs/InputLabel.vue'
import InputError from '@/components/inputs/InputError.vue'
import Dropdown from 'primevue/dropdown'
import { useField } from 'vee-validate'
import {onMounted} from 'vue'

const props = defineProps<{
  inputName: string
  label?: string
  options: any[] | undefined
  disabled?: boolean
  optionLabel?: string
  optionValue?: string
  id: string
  viewOnly?: boolean
  placeholder?: string
}>()

const { value, errorMessage } = useField(() => props.inputName)

onMounted(() => {
  if (props.options?.length === 1 && value.value === undefined) {
    value.value = props.options[0][props.optionValue ?? 'value']
  }
})
</script>

<template>
  <div class="flex flex-col">
    <InputLabel :forInput="id">{{ label }}</InputLabel>
    <Dropdown
      :disabled="viewOnly"
      :optionLabel="optionLabel"
      :optionValue="optionValue"
      :options="options"
      :id="id"
      :invalid="!!errorMessage"
      v-model="value"
      :placeholder="placeholder"
    />

    <InputError v-show="errorMessage">{{ errorMessage }}</InputError>
  </div>
</template>
<style></style>
